import { motion } from "framer-motion";
import { FiFilter } from "react-icons/fi";

const EmptyStateComponent = ({
    darkMode,
    filteredProducts,
    secondaryTextColor,
}) => {
  return (
    <>
      {filteredProducts?.length === 0 && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center py-16"
        >
          <FiFilter className={`text-6xl ${darkMode ? "text-gray-600" : "text-gray-400"} mx-auto mb-4`} />
          <h3 className="text-2xl font-bold mb-2">No products found</h3>
          <p className={secondaryTextColor}>Try adjusting your filters or search query</p>
        </motion.div>
      )}
    </>
  )
}

export default EmptyStateComponent